/**
 * theme-test.js
 */


import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
  useTheme,
} from '@mui/material/styles';


const useStyles = makeStyles(theme => ({
  outerThemeContainer: {
    padding: theme.spacing(2),
  },
  swatch: {
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
  },
  swatchDesc: {
    paddingBlock: theme.spacing(2),
  },
  swatchName: {
    fontSize: '1.1em',
    fontWeight: 700,
  },
}));


const colorCategories = [
  'primary',
  'secondary',
  'success',
  'error',
  'warning',
  'coolGrey',
  'blueGrey',
];


// const colorWeights = [
//   '25',
//   '50',
//   '100',
//   '200',
//   '300',
//   '400',
//   '500',
//   '600',
//   '700',
//   '800',
//   '900',
//   'A100',
//   'A200',
//   'A400',
//   'A700',
// ];


const ThemeTestWithTheme = props => {
  const classes = useStyles();
  const theme = useTheme();


  return (
    <Grid container
      className={classes.outerThemeContainer}
    >
      <Grid item xs={12}>
        <Box py={3}>
          <Typography variant="h3">Named Palette Colours:</Typography>
          {colorCategories
            .map((colorCategory, ccIdx) => (
              <Box my={4} key={ccIdx}>
                <Typography variant="h4" style={{ marginBottom: theme.spacing(2) }}>{colorCategory}</Typography>
                {Object.keys(theme.palette[colorCategory])
                  .map((colorName, cnIdx) => {
                    return (
                      (colorName !== 'colors') &&
                      <Grid container
                        key={cnIdx}
                      >
                        <Grid item xs={2} className={classes.swatchDesc}>
                          <Typography variant="h5">{colorName}</Typography> {theme.palette[colorCategory][colorName]}
                        </Grid>
                        <Grid item xs={10}
                          className={classes.swatch}
                          style={{
                            color: cnIdx <= 5 ? 'black' : 'white',
                            backgroundColor: theme.palette[colorCategory][colorName],
                          }}
                        >
                        </Grid>
                      </Grid>
                    );
                  })}
              </Box>
            ))
          }
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box py={3}>
          <Typography variant="h3">All Theme Colours:</Typography>
          {colorCategories
            .map(colorName =>
              theme.palette[colorName]?.colors
                ?.map((color, idx) => {
                  return (
                    <Grid item xs={12}
                      key={idx}
                      className={classes.swatch}
                      style={{
                        color: idx <= 5 ? 'white' : 'black',
                        backgroundColor: color
                      }}
                    >
                      theme.palette.{colorName}[{idx}] = {color}
                      <br />
                      <div className={classes.swatchName}>
                        {Object.keys(theme.palette[colorName]).find(key => theme.palette[colorName][key] === color)}
                      </div>
                    </Grid>
                  );
                })
            )
          }
        </Box>
      </Grid>
    </Grid>
  );

};


const ThemeTest = props => {
  return (
    <ThemeTestWithTheme />
  );

};


export default ThemeTest;